import { useQuery } from '@tanstack/react-query';

import { fetchData } from 'src/app/queries';

import type { QueryKey } from '@tanstack/react-query';

export const GET_SPRINGBIG_OFFERS = 'api/springbig/get-configured-offers-rewards';

export const springBigOffersQueryKey: QueryKey = ['springbig-offers'];

// LeafLogix.Web/Dutchie.Common.Domain/Models/Register/Loyalty/SpringBig/SpringBigImage.cs
export type SpringBigImage = {
  label: string;
  thumb: string;
  url: string;
};

// LeafLogix.Web/Dutchie.Common.Domain/Models/Register/Loyalty/SpringBig/SpringBigConfiguredOfferReward.cs
export type SpringBigConfiguredOfferReward = {
  active: boolean;
  cash_reward: boolean;
  description: string;
  discount_amount: string;
  discount_type: string;
  expiration_date: string | null;
  id: number;
  images: SpringBigImage[];
  item_value: number;
  max_redemptions: number;
  meta: string;
  name: string;
};

export function useGetSpringBigOffersQuery(enabled = true) {
  return useQuery({
    enabled,
    queryFn: () => fetchData<SpringBigConfiguredOfferReward[]>(GET_SPRINGBIG_OFFERS),
    queryKey: springBigOffersQueryKey,
  });
}
